<template>
  <div class="submenu">
    <ul class="submenu__list">
      <li v-for="item in left" :key="item.key || item.title" :class="{ active: item.active }">
        <router-link v-if="item.to" :to="item.to">
          {{ item.title }}
          <MarketplaceUnreadBadge v-if="item.count !== undefined" :count="item.count" />
        </router-link>
        <a v-else :href="item.href">
          {{ item.title }}
          <MarketplaceUnreadBadge v-if="item.count !== undefined" :count="item.count" />
        </a>
      </li>
    </ul>
    <ul class="submenu__list">
      <li v-for="item in right" :key="item.key || item.title" :class="{ active: item.active }">
        <router-link v-if="item.to" :to="item.to">
          {{ item.title }}
          <MarketplaceUnreadBadge v-if="item.count !== undefined" :count="item.count" />
        </router-link>
        <a v-else :href="item.href">
          {{ item.title }}
          <MarketplaceUnreadBadge v-if="item.count !== undefined" :count="item.count" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import MarketplaceUnreadBadge from '@/components/matchmaking/MarketplaceUnreadBadge.vue';

export default {
  name: 'SubmenuBar',
  components: {
    MarketplaceUnreadBadge,
  },
  props: {
    left: { type: Array, default: () => [] },
    right: { type: Array, default: () => [] },
  },
};
</script>
